import { render, staticRenderFns } from "./mersOrgCombobox.vue?vue&type=template&id=23ad3154&scoped=true"
import script from "./mersOrgCombobox.vue?vue&type=script&lang=js"
export * from "./mersOrgCombobox.vue?vue&type=script&lang=js"
import style0 from "./mersOrgCombobox.vue?vue&type=style&index=0&id=23ad3154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ad3154",
  null
  
)

export default component.exports